import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditolgatpuricab() {



    const cardData = {





keyword: "Shirdi to Igatpuri Cab",

headingDescription: "Sai Shirdi Cab provides comfortable and reliable Shirdi to Igatpuri Cab service for families, couples, tourists, devotees, senior citizens, and groups planning a scenic journey from Shirdi to Igatpuri. Customers can book private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way travel, round trips, weekend getaways, sightseeing tours, family vacations, and customized multi-day itineraries. Igatpuri is known for its mountains, valleys, waterfalls, greenery, and peaceful surroundings, making it a popular destination for travelers looking for a nature-focused break after their Shirdi visit. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup timings, and convenient return arrangements, Sai Shirdi Cab makes the journey simple and comfortable. Travelers can also combine Igatpuri with Nashik, Trimbakeshwar, Bhandardara, and other nearby Maharashtra destinations.",

topPlaces: [
  {
    title: "Igatpuri",
    description: "Igatpuri is the main destination for this journey and is a popular hill getaway surrounded by the Sahyadri mountains. Travelers from Shirdi can book a private cab for direct hotel transfers, sightseeing, or weekend travel. One-way and round-trip options make the service suitable for couples, families, and small groups."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious and cultural destination that can be combined with a Shirdi to Igatpuri journey. Travelers can explore temples, heritage attractions, vineyards, and scenic locations around the city. Private cab service allows customers to include Nashik as a convenient sightseeing or pilgrimage stop."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a renowned Jyotirlinga pilgrimage destination near Nashik and is ideal for travelers who want to combine a religious visit with their Igatpuri getaway. Devotees can include the temple in their customized itinerary from Shirdi. Sai Shirdi Cab provides comfortable private transportation for families and pilgrimage groups."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a scenic destination known for its lake, mountains, waterfalls, forests, and peaceful natural surroundings. Travelers can combine Bhandardara with Igatpuri for an extended nature tour from Shirdi. A private cab provides flexibility to explore scenic locations while carrying luggage comfortably."
  },
  {
    title: "Kalsubai",
    description: "Kalsubai is famous for its high mountain peak and attracts trekkers, adventure enthusiasts, and nature lovers. Travelers planning an outdoor trip from Shirdi can include the Kalsubai region along with Igatpuri. Customers can arrange a suitable private vehicle with flexible travel timings and convenient pickup and drop points."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a popular pilgrimage destination near Shirdi and can be combined with an Igatpuri sightseeing trip. Devotees can visit the temple before continuing toward the scenic hill region. Private cab service allows travelers to combine religious and leisure destinations within one customized Maharashtra itinerary."
  },
  {
    title: "Saptashrungi Gad",
    description: "Saptashrungi Gad is an important Shakti pilgrimage destination in the Nashik region and can be included in an extended Shirdi to Igatpuri religious and sightseeing tour. Families and devotees can customize their route to include the shrine along with Nashik. Comfortable vehicles are available for multi-stop journeys."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a scenic mountain destination known for misty hills, valleys, waterfalls, and beautiful monsoon landscapes. Travelers looking for an extended nature tour can combine Malshej Ghat with Igatpuri. Sai Shirdi Cab provides private transportation that allows flexible sightseeing stops and convenient return planning."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for viewpoints, valleys, waterfalls, lakes, and strawberry farms. Travelers can extend their Shirdi to Igatpuri trip into a longer Maharashtra hill-station tour. Families and groups can choose a spacious vehicle for comfortable multi-day travel with luggage."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is a major heritage destination with historic monuments, temples, caves, and cultural attractions. Travelers can include the city in a broader Maharashtra tour along with Shirdi and Igatpuri. Private cab transportation provides flexibility for sightseeing and multi-day travel arrangements."
  },
  {
    title: "Pune",
    description: "Pune is a major business, educational, and technology center and can be included as an additional destination during an extended Maharashtra road trip. Travelers from Shirdi can combine Pune with Igatpuri according to their itinerary. Comfortable private cabs are suitable for families, professionals, and small groups."
  }
],



"services": [
{
"name": "Shirdi to Igatpuri Cab",
"description": "Shirdi to Igatpuri Cab provides convenient private transportation for travelers planning a journey between Shirdi and Igatpuri. The service can be arranged for direct travel, sightseeing, family trips, and onward journeys with vehicle options based on passenger requirements."
},
{
"name": "Shirdi to Igatpuri Taxi Fare",
"description": "Shirdi to Igatpuri Taxi Fare depends on the selected vehicle, journey type, passenger count, and travel requirements. Customers can choose a suitable cab for one-way travel, round trips, sightseeing, or customized itineraries between Shirdi and Igatpuri."
},
{
"name": "Shirdi to Igatpuri Cab Booking",
"description": "Shirdi to Igatpuri Cab Booking allows travelers to arrange private transportation in advance for a planned journey. Cab service can be scheduled according to the preferred departure time, vehicle type, passenger capacity, luggage requirements, and travel itinerary."
},
{
"name": "Top-Rated Shirdi to Igatpuri Cabs",
"description": "Top-Rated Shirdi to Igatpuri Cabs offer a comfortable travel option for passengers looking for private transportation on this route. Different vehicle categories can be arranged for individuals, families, and groups depending on their space and travel requirements."
},
{
"name": "Shirdi to Igatpuri Swift Dzire Cab Booking",
"description": "Shirdi to Igatpuri Swift Dzire Cab Booking provides a convenient sedan option for individuals and small families traveling between the two destinations. The cab can be arranged for direct transfers, sightseeing trips, one-way journeys, or planned return travel."
},
{
"name": "Shirdi to Igatpuri Tempo Traveller on Rent",
"description": "Shirdi to Igatpuri Tempo Traveller on Rent is suitable for families and groups requiring additional seating and luggage space. Tempo Traveller service can be arranged for sightseeing, group outings, pilgrimage travel, and customized journeys between Shirdi and Igatpuri."
},
{
"name": "Shirdi to Igatpuri Nashik Darshan Cab",
"description": "Shirdi to Igatpuri Nashik Darshan Cab provides a flexible travel option for visitors combining Igatpuri and Nashik sightseeing with their Shirdi trip. The itinerary can include temple visits, local attractions, sightseeing stops, and convenient return or onward transportation."
},
{
"name": "Shirdi to Igatpuri Innova Crysta on Rent",
"description": "Shirdi to Igatpuri Innova Crysta on Rent offers a spacious and comfortable cab option for families and groups traveling on the route. The vehicle can be arranged for one-way trips, round trips, sightseeing, and longer journeys requiring additional passenger and luggage space."
},
{
"name": "Shirdi to Igatpuri Innova Crysta Cab Booking",
"description": "Shirdi to Igatpuri Innova Crysta Cab Booking allows travelers to reserve a spacious vehicle for comfortable private transportation. The cab can be planned around the preferred departure schedule and used for direct travel, sightseeing, family trips, or return journeys."
},
{
"name": "Shani Shingnapur to Igatpuri Nashik Cab Booking",
"description": "Shani Shingnapur to Igatpuri Nashik Cab Booking provides private transportation for travelers combining pilgrimage and sightseeing destinations. The cab can be planned for Shani Shingnapur, Igatpuri, Nashik, and additional stops according to the selected travel itinerary."
},
{
"name": "Shirdi to Igatpuri Cab Packages",
"description": "Shirdi to Igatpuri Cab Packages provide flexible transportation options for travelers planning short trips, sightseeing tours, and multi-destination journeys. Packages can be customized according to vehicle category, number of passengers, travel duration, and selected destinations."
},
{
"name": "Shirdi to Igatpuri Xcent Cab",
"description": "Shirdi to Igatpuri Xcent Cab provides a comfortable sedan option for travelers looking for private transportation between Shirdi and Igatpuri. The cab can be arranged for direct travel, one-way transfers, sightseeing requirements, and scheduled return journeys."
},
{
"name": "Shirdi to Igatpuri Ertiga Package",
"description": "Shirdi to Igatpuri Ertiga Package is suitable for families and small groups requiring a spacious vehicle for their journey. The package can cover direct travel, sightseeing, luggage transportation, and return trips based on the preferred itinerary."
},
{
"name": "Shirdi to Igatpuri Ertiga Cab",
"description": "Shirdi to Igatpuri Ertiga Cab offers a practical seven-seater travel option for families and groups. Ertiga cab service can be arranged for one-way travel, round trips, sightseeing, and customized routes with convenient pickup and drop-off arrangements."
},
{
"name": "Shirdi to Nashik Tour Packages",
"description": "Shirdi to Nashik Tour Packages combine convenient private cab transportation with sightseeing and pilgrimage travel between Shirdi and Nashik. The itinerary can include Sai Baba Darshan, Nashik temples, Trimbakeshwar, local attractions, hotel transfers, and return transportation."
}
],
"tableData": [
["Shirdi to Igatpuri Cab", "Shirdi to Igatpuri Taxi Fare"],
["Shirdi to Igatpuri Cab Booking", "Top-Rated Shirdi to Igatpuri Cabs"],
["Shirdi to Igatpuri Swift Dzire Cab Booking", "Shirdi to Igatpuri Tempo Traveller on Rent"],
["Shirdi to Igatpuri Nashik Darshan Cab", "Shirdi to Igatpuri Innova Crysta on Rent"],
["Shirdi to Igatpuri Innova Crysta Cab Booking", "Shani Shingnapur to Igatpuri Nashik Cab Booking"],
["Shirdi to Igatpuri Cab Packages", "Shirdi to Igatpuri Xcent Cab"],
["Shirdi to Igatpuri Ertiga Package", "Shirdi to Igatpuri Ertiga Cab"],
["Shirdi to Nashik Tour Packages", "Shirdi to Igatpuri Innova Crysta Cab Booking"]
],















        whychoose: [
            { 
                WhyChooseheading: "Nashik Airport to Shirdi Cab for Pilgrimage Transfers", 
                WhyChoosedescription: "Sai Shirdi Cabs offers private taxi transportation from Nashik Airport to Shirdi for devotees, families, tourists, senior citizens, and business travellers. A dedicated cab provides direct airport-to-Shirdi travel with space for passengers and their luggage." 
            }, 
            { 
                WhyChooseheading: "Airport Pickup Based on Your Flight Schedule", 
                WhyChoosedescription: "Share your Nashik Airport arrival details while booking so the pickup can be planned around your flight schedule. Passengers can continue towards Shirdi after landing without arranging separate local transportation." 
            }, 
            { 
                WhyChooseheading: "Direct Travel Towards Sai Baba Temple", 
                WhyChoosedescription: "Devotees arriving at Nashik Airport can travel directly towards Shirdi and their preferred hotel or destination near Sai Baba Temple. The private transfer avoids the inconvenience of changing vehicles during the journey." 
            }, 
            { 
                WhyChooseheading: "Comfortable Option for Family Pilgrimages", 
                WhyChoosedescription: "Families travelling with children, senior citizens, and pilgrimage luggage can select a suitable cab according to their group size. Having a dedicated vehicle allows everyone to travel together from the airport to Shirdi." 
            }, 
            { 
                WhyChooseheading: "Useful for Sai Baba Darshan Planning", 
                WhyChoosedescription: "Travellers can coordinate their airport arrival and Shirdi visit around their Darshan plans. A private cab provides flexibility to continue towards the pilgrimage destination after completing the airport transfer." 
            }, 
            { 
                WhyChooseheading: "One-Way Airport Drop to Shirdi", 
                WhyChoosedescription: "Passengers who only require transportation from Nashik Airport to Shirdi can choose a one-way cab. This is suitable when separate arrangements have already been made for local travel or the return journey." 
            }, 
            { 
                WhyChooseheading: "Vehicle Options for Different Group Sizes", 
                WhyChoosedescription: "Cab options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage quantity, and preferred comfort level for the airport transfer." 
            }, 
            { 
                WhyChooseheading: "Book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs", 
                WhyChoosedescription: "Provide your Nashik Airport arrival details, pickup information, Shirdi destination, travel date, passenger count, luggage requirements, and preferred vehicle to Sai Shirdi Cabs for a suitable private airport cab arrangement." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I book a cab from Nashik Airport to Shirdi?", 
            answer: "Yes, Sai Shirdi Cabs provides private cab services from Nashik Airport to Shirdi for devotees, families, tourists, senior citizens, and other travellers." 
        }, 
        { 
            question: "Can I get pickup from Nashik Airport after my flight arrives?", 
            answer: "Yes, passengers can arrange airport pickup by sharing their flight details and expected arrival information during the booking process." 
        }, 
        { 
            question: "Can I travel directly from Nashik Airport to Shirdi?", 
            answer: "Yes, a private cab provides direct transportation from Nashik Airport to Shirdi, allowing passengers to continue their journey without arranging multiple connecting vehicles." 
        }, 
        { 
            question: "Is Nashik Airport to Shirdi Cab suitable for Sai Baba Darshan?", 
            answer: "Yes, the service is suitable for devotees arriving at Nashik Airport and travelling to Shirdi for Sai Baba Darshan and other pilgrimage activities." 
        }, 
        { 
            question: "Can families book a taxi from Nashik Airport to Shirdi?", 
            answer: "Yes, families can select a suitable vehicle according to passenger count, luggage requirements, and preferred comfort level for the airport-to-Shirdi journey." 
        }, 
        { 
            question: "Do you provide one-way Nashik Airport to Shirdi Cab service?", 
            answer: "Yes, one-way cab service is available for passengers who need direct transportation from Nashik Airport to Shirdi without requiring the same vehicle for the return journey." 
        }, 
        { 
            question: "Can I book a return cab from Shirdi to Nashik Airport?", 
            answer: "Yes, return transportation can be discussed for passengers who need to travel from Shirdi back towards Nashik Airport after completing their pilgrimage or stay." 
        }, 
        { 
            question: "Which vehicles are available for Nashik Airport to Shirdi travel?", 
            answer: "Vehicle options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage, and travel requirements." 
        }, 
        { 
            question: "Can I carry luggage from Nashik Airport to Shirdi?", 
            answer: "Yes, passengers can carry airport luggage according to the available storage capacity of the selected vehicle. Bulky or additional baggage should be mentioned during booking." 
        }, 
        { 
            question: "How can I book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs?", 
            answer: "Share your flight details, Nashik Airport arrival time, Shirdi destination, travel date, passenger information, luggage requirements, and preferred vehicle with Sai Shirdi Cabs to proceed with the cab booking." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Prakash Gaikwad", 
            feedback: "We landed at Nashik Airport and needed to continue to Shirdi with our family. The private cab was convenient because we could travel directly with our luggage and avoid changing vehicles.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Meena Joshi", 
            feedback: "Our Shirdi pilgrimage started after arriving at Nashik Airport. We booked a private taxi for the transfer and found it much easier to travel together with our parents and bags.", 
            rating: 5 
        } 
    ];




    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Igatpuri Cab on Rent",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-igatpuri-cab-on-rent.webp",
  "description":
    "Book Shirdi to Igatpuri Cab on Rent with Sai Shirdi Cabs for safe, comfortable, and reliable taxi services. We provide one-way, round-trip, and full-day cab options from Shirdi to Igatpuri for sightseeing, Nashik Darshan, family trips, weekend travel, and pilgrimage journeys. Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller with professional drivers, convenient pickup and drop, flexible packages, and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-igatpuri-cab-on-rent"
  }
};







    return (
        <div>

<Helmet>
  <title>Shirdi to Igatpuri Cab on Rent | Igatpuri Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Igatpuri Cab on Rent with Sai Shirdi Cabs for affordable one-way, round-trip and sightseeing taxi services. Hire Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta and Tempo Traveller from Shirdi to Igatpuri for Nashik Darshan, family trips and weekend travel."
  />

  <meta
    name="keywords"
    content="Shirdi to Igatpuri Cab on Rent, Shirdi to Igatpuri Cab, Shirdi to Igatpuri Taxi Fare, Shirdi to Igatpuri Cab Booking, Top-rated Shirdi to Igatpuri Cabs, Shirdi To Igatpuri Swift Dzire Cab Booking, Shirdi to Igatpuri Tempo Traveller on Rent, Shirdi to Igatpuri Nashik Darshan Cab, Shirdi to Igatpuri Innova Crysta on Rent, Shirdi To Igatpuri Innova Crysta Cab Booking, Shirdi to Igatpuri Taxi, Shirdi to Igatpuri Cab Service, Shirdi to Igatpuri Taxi Service, Shirdi to Igatpuri One Way Cab, Shirdi to Igatpuri One Way Taxi, Shirdi to Igatpuri Round Trip Cab, Shirdi to Igatpuri Round Trip Taxi, Shirdi to Igatpuri Cab Fare, Shirdi to Igatpuri Taxi Booking, Shirdi to Igatpuri Online Cab Booking, Shirdi Igatpuri Cab, Shirdi Igatpuri Taxi, Igatpuri to Shirdi Cab, Igatpuri to Shirdi Taxi, Igatpuri to Shirdi Cab Service, Igatpuri to Shirdi Taxi Service, Shirdi to Igatpuri Car Rental, Shirdi to Igatpuri Car Hire, Shirdi to Igatpuri Sedan Cab, Shirdi to Igatpuri Swift Dzire Taxi, Shirdi to Igatpuri Ertiga Cab, Shirdi to Igatpuri Innova Cab, Shirdi to Igatpuri Innova Crysta Taxi, Shirdi to Igatpuri Tempo Traveller, Shirdi to Igatpuri Tempo Traveller Rental, Shirdi to Igatpuri Full Day Cab, Shirdi to Igatpuri Full Day Taxi, Shirdi to Igatpuri Sightseeing Cab, Shirdi to Igatpuri Tour Package, Shirdi to Igatpuri One Day Trip, Shirdi to Igatpuri One Day Tour, Shirdi to Igatpuri Nashik Tour Cab, Shirdi to Igatpuri Nashik Darshan Taxi, Shirdi to Igatpuri Family Cab, Shirdi to Igatpuri Weekend Trip Taxi, Affordable Shirdi to Igatpuri Cab, Best Shirdi to Igatpuri Taxi, Reliable Shirdi to Igatpuri Cab Service, Cheap Shirdi to Igatpuri Taxi, Shirdi to Igatpuri Travel Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditolgatpuricab;